import {
    Button, Dialog, DialogActions, DialogContent,
    DialogTitle, IconButton, Typography,
} from "@mui/material";
import {CheckCircleOutline, Close, ErrorOutline} from "@mui/icons-material";
import {useTranslation} from "react-i18next";

interface ResultDialogProps {
    open: boolean;
    success: boolean;
    /** Titolo personalizzato (gia' tradotto). Se assente usa i testi di salvataggio. */
    title?: string;
    /** Messaggio personalizzato (gia' tradotto). Se assente usa i testi di salvataggio. */
    message?: string;
    /** Messaggio di errore custom, usato quando success=false e non e' passato "message". */
    errorMessage?: string;
    onClose: () => void;
}

const ResultDialog = ({open, success, title, message, errorMessage, onClose}: ResultDialogProps) => {
    const {t} = useTranslation("templates");

    const resolvedTitle = title ?? (success
        ? t('saveResultDialog.successTitle')
        : t('saveResultDialog.errorTitle'));

    const resolvedMessage = message ?? (success
        ? t('saveResultDialog.successMessage')
        : (errorMessage || t('saveResultDialog.errorMessage')));

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                {resolvedTitle}
                <IconButton size="small" onClick={onClose}><Close/></IconButton>
            </DialogTitle>
            <DialogContent sx={{display: 'flex', alignItems: 'center', gap: 2, pt: 2}}>
                {success
                    ? <CheckCircleOutline color="success" sx={{fontSize: 40}}/>
                    : <ErrorOutline color="error" sx={{fontSize: 40}}/>
                }
                <Typography variant="body1">{resolvedMessage}</Typography>
            </DialogContent>
            <DialogActions sx={{px: 3, pb: 2}}>
                <Button variant="contained" onClick={onClose}>
                    {t('saveResultDialog.close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ResultDialog;
